<template>
  <el-dialog
    width="788px"
    :visible.sync="modelValue"
    title="浏览照片集"
    custom-class="relic-detail-census-swiper"
  >
    <!-- 图片本身 -->
    <img :src="swiperImgInformation.url" class="swiper-img__container" />

    <!-- 图片信息 -->
    <div class="swiper-info__container">
      <!-- 信息 -->
      <div class="swiper-info">
        <!-- input -->
        <edit-input-vue
          v-model="info.value"
          v-for="(info, index) in imgInfoByKid"
          :key="index"
          :label="info.label"
          :edit="visibleEdit"
          :options="info.options"
        />
      </div>
      <!-- 编辑按钮 -->
      <edit-header-vue
        v-model="visibleEdit"
        @onSaveClick="handleSaveImgInformation"
        @onCancelClick="handleCancelImgInformation"
        @onEditClick="handleEditImgInformation"
      />
    </div>

    <template v-slot:footer>
      <el-button
        type="text"
        class="swiper-action"
        icon="el-icon-arrow-left"
        @click="handleLastImg"
      ></el-button>
      <el-button
        type="text"
        class="swiper-action"
        icon="el-icon-arrow-right"
        @click="handleNextImg"
      ></el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { updateRelicPhoto, updateRelicDrawing } from '../../api';
import { modelMixin } from '../../assets/js/mixins/model';
import editHeaderVue from '../layout/edit-header.vue';
import editInputVue from '../layout/edit-input.vue';
export default {
  name: 'RelicDetailCensusSwiper',

  mixins: [modelMixin],

  components: { editHeaderVue, editInputVue },

  props: {
    imgInfoByKid: {
      type: Array,
      required: true
    },
    swiperImgInformation: {
      type: Object,
      required: true
    },
    imgType: {
      type: Number,
      required: true
    },
    swiperImgIndex: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters('relic', ['gettersRelicDetail'])
    // visibleEdit() {
    //   return this.swiperImgInformation.visibleEdit;
    // }
  },
  data() {
    return {
      visibleEdit: false,
      imgInformation: ''
    };
  },
  methods: {
    /**
     * 点击下一张
     */
    handleNextImg() {
      if (this.imgType == 1) {
        let imgIndex = this.swiperImgIndex + 1;
        this.$emit('onToNextPhotoSlide', imgIndex);
      } else if (this.imgType == 2) {
        let imgIndex = this.swiperImgIndex + 1;
        this.$emit('onToNextDrawSlide', imgIndex);
      }
    },
    /**
     * 点击上一张
     */
    handleLastImg() {
      if (this.imgType == 1) {
        let imgIndex = this.swiperImgIndex - 1;
        this.$emit('onToLastPhotoSlide', imgIndex);
      } else if (this.imgType == 2) {
        let imgIndex = this.swiperImgIndex - 1;
        this.$emit('onToLastDrawSlide', imgIndex);
      }
    },
    /**
     * 确认修改img信息
     */
    handleSaveImgInformation() {
      if (this.imgType == 1) {
        this.imgInformation = JSON.parse(JSON.stringify(this.imgInfoByKid));
        updateRelicPhoto({
          description: this.imgInfoByKid[6].value,
          filmId: this.imgInfoByKid[2].value,
          photoId: this.imgInfoByKid[1].value,
          photoName: this.imgInfoByKid[0].value,
          photographer: this.imgInfoByKid[3].value,
          relicAutoIncrementId: this.gettersRelicDetail.relicAutoIncrementId,
          relicPhotoAutoIncrementId: this.swiperImgInformation
            .relicPhotoAutoIncrementId,
          shootDirection: this.imgInfoByKid[5].value,
          shootTime: this.imgInfoByKid[4].value
        }).then(res => {});
      } else if (this.imgType == 2) {
        this.imgInformation = JSON.parse(JSON.stringify(this.imgInfoByKid));
        updateRelicDrawing({
          createTime: this.imgInfoByKid[4].value,
          creator: this.imgInfoByKid[3].value,
          drawingId: this.imgInfoByKid[1].value,
          drawingName: this.imgInfoByKid[0].value,
          relicAutoIncrementId: this.gettersRelicDetail.relicAutoIncrementId,
          relicDrawingAutoIncrementId: this.swiperImgInformation
            .relicDrawingAutoIncrementId,
          scale: this.imgInfoByKid[2].value
        }).then(res => {
          if (res.data.code == 200) {
            this.$prompt('修改成功');
          }
        });
      }
    },
    /**
     * 监听编辑回掉
     */
    handleEditImgInformation() {
      this.imgInformation = JSON.parse(JSON.stringify(this.imgInfoByKid));
    },
    /**
     * 取消修改img信息
     */
    handleCancelImgInformation() {
      this.imgInfoByKid = JSON.parse(JSON.stringify(this.imgInformation));
    }
  }
};
</script>

<style lang="scss">
.relic-detail-census-swiper {
  margin-top: 0 !important;
  margin-bottom: 0;
  top: 50%;
  transform: translateY(-50%);
  .el-dialog {
    &__header {
      padding-top: 23px;
      padding-left: 36px;
    }
    &__title {
      font-size: 22px;
      color: #333;
      font-family: 'Arial Negreta';
    }
    &__headerbtn {
      font-size: 35px;
      line-height: 1;
      top: -4px;
      right: -42px;
    }
    &__close {
      color: #fff;
    }
    &__body {
      position: relative;
      padding: 54px;
      z-index: 1;
    }
    &__footer {
      display: flex;
      position: absolute;
      justify-content: space-between;
      padding: 0;
      width: 130%;
      left: 50%;
      top: 40%;
      transform: translate(-50%, -50%);
    }
  }
  .swiper {
    &-img {
      &__container {
        height: 400px;
        width: 100%;
        background-color: #f2f2f2;
      }
    }
    &-info {
      flex: 1;
      &__container {
        display: flex;
        margin-top: 52px;
      }
    }
    &-action {
      font-size: 55px;
      font-weight: bold;
      color: #fff;
    }
  }
  .edit-header {
    align-items: flex-start;
    border: 0;
  }
  .edit-input {
    &__label {
      position: relative;
      width: 75px;
      text-align-last: justify;
      &::after {
        content: ':';
        position: absolute;
        transform: translateY(-50%);
        right: -6px;
        top: 50%;
      }
    }
  }
}
</style>
